// CoverFitLikeProd.jsx
import React, { useState } from "react";
import TripleSpinner from "./TripleSpinner"; // твой тройной спинер

/**
 * Поведение 1:1 с продом:
 * - у <img> НЕТ фиксированных width/height
 * - только maxWidth / maxHeight + objectFit:'contain'
 * - рамка фикс. размера, скругление на рамке (и дублируем на img)
 */
const CoverFitLikeProd = ({
                              src,
                              fallbackSrc,
                              alt = "",
                              boxW = 86,           // = твой прежний maxWidth
                              boxH = 116,          // = твой прежний maxHeight
                              radius = 4,          // одинаковый радиус
                              padding = 2,         // как у тебя было
                              spinnerSize = 24,
                              style = {},
                          }) => {
    const [loaded, setLoaded] = useState(false);
    const [err, setErr] = useState(false);
    const finalSrc = err ? fallbackSrc : src;

    return (
        <div
            style={{
                position: "relative",
                width: boxW,
                height: boxH,
                borderRadius: radius,
                overflow: "hidden",       // скруглённая рамка
                background: "#fff",
                ...style,
            }}
        >
            {!loaded && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background:
                            "linear-gradient(90deg,#f5f5f5 25%,#ececec 37%,#f5f5f5 63%)",
                        backgroundSize: "400% 100%",
                        animation: "shimmer 1.1s linear infinite",
                    }}
                    aria-hidden="true"
                >
                    <TripleSpinner size={spinnerSize} />
                </div>
            )}

            {/* ВАЖНО: width/height у img не задаём! Только max* + contain */}
            <img
                src={finalSrc}
                alt={alt}
                loading="lazy"
                decoding="async"
                onLoad={() => setLoaded(true)}
                onError={() => { setErr(true); setLoaded(true); }}
                style={{
                    width: "auto",
                    height: "auto",
                    maxWidth: boxW - padding * 2,
                    maxHeight: boxH - padding * 2,
                    objectFit: "contain",
                    display: "block",
                    padding,
                    borderRadius: radius,        // дублируем радиус (как у тебя)
                    backgroundColor: "white",
                    opacity: loaded ? 1 : 0,
                    transition: "opacity 180ms ease",
                }}
            />
        </div>
    );
};

export default CoverFitLikeProd;
